import React, { useState, useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import axios from "axios";
import Table from "react-bootstrap/Table";
import loading1 from "../../assets/img/loading-gif.gif";
import loadingwithdraww from "../../assets/img/loading-gif.gif";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import $ from "jquery";
import { fetchwalletamount } from "../../common.js";
import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { PiHandDepositFill } from "react-icons/pi";

import { Button, Form, Input, message, Space, Modal } from "antd";
import Withdrawhistory from "./Withdrawhistory.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoArrowBackSharp } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";
export default function DepositPage() {
  const navigate = useNavigate();
  const [walletAmount, setWalletAmount] = useState(null);
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const Navigatehome = () => {
    navigate("/");
  }
  const [usernameError, setUsernameError] = useState(null);
  const [username, setUsername] = useState("");
  const [selectedOption, setSelectedOption] = useState(true);
  const [userProfile, setUserProfile] = useState(null);
  const [amountvalue, setvalue] = useState("");
  const [users, setUsers] = useState([]);
  const [user, setUsers1] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [userData, setUserData] = useState(null);
  const [appmanager, setAppmanager] = useState({ min_deposit: 0 });
  const [totalSuccessAmount, settotalSuccessAmount] = useState(0);
  const [minredeem, setMinredeem] = useState(null);
  const [Deposit, setDeposit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [winamount, setwinamount] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadingwithdraw, setLoadingwithdraw] = useState(false);
  const [loadingwallet, setLoadingwallet] = useState(false);
  const [msg, setmsg] = useState("");
  const [msgwallet, setmsgwallet] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const isButtonLoading = useRef(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valueswithdraw, setValueswithdraw] = useState([]);
  const [balance, setBalance] = useState(null);
  const [selectedBanks, setSelectedBanks] = useState({
    bankId: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    accountHolderName: "",
  });
  const [filteredValues1, setFilteredValues1] = useState([]); // Store filtered bank list
  const [bankNames, setBankNames] = useState("");
  const userid = localStorage.getItem("userid");
  const changevalue = (e) => {
    setvalue(e.target.value);
  };
  // const handleButtonClickdeposit = (amount) => {
  //   // setSelectedAmount(amount);
  //   setInputValuedeposit(amount);
  // };
  const isAdmined = localStorage.getItem("isAdmin");
  const userTokened = localStorage.getItem("userToken");
  useEffect(() => {

    if (!userTokened || !isAdmined === "false") {
      navigate("/");
      localStorage.clear();
    }
  }, [!isAdmined]);
  const handleButtonClickdeposit = (amount) => {
    setInputValuedeposit((prevValue) => {
      const newValue = prevValue ? parseInt(prevValue) + parseInt(amount) : parseInt(amount);
      return newValue.toString();
    });
  };
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const [form] = Form.useForm();

  const onFinish = () => {
    // message.success('Submit success!');
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  useEffect(() => {
    loaduser1();
  }, []);


  const [paginate, setpaginate] = useState(1);
  const [loadbuttonshow, setloadbuttonshow] = useState();
  const [eposit_enabled, setdeposit_enabled] = useState();
  console.warn("111111111", eposit_enabled)
  let firstNumbers = [];

  const shoot = () => {
    // loaduser();
  };

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`https://api.Cash365days.in/user/user-profile`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: userid }),
        });

        const data = await response.json();
        if (data.success === 1) {

          setBalance(data.user.balance); // Set balance in state
        } else {
          console.error("Error:", data.message);
        }
      } catch (err) {
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userid]);
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`https://api.Cash365days.in/user/settings`);
        const data = await response.json();

        console.log("API 👉", data);

        // safe access
        const depositValue = data?.data?.deposit_enabled || data?.deposit_enabled;

        setdeposit_enabled(depositValue);

      } catch (err) {
        console.error("Failed to fetch user profile", err);
      }
    };

    fetchUserProfile();
  }, []);
  const loaduser1 = async () => {
    const userid = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    setLoadingwithdraw(true);
    let url = `https://api.Cash365days.in/user/user-transaction-history/${userid}`;
    // let url = `${process.env.REACT_APP_API_URL_NODE}user/user-transaction-history/${userid}`;


    var config = {
      method: "get",
      url: url
    };
    axios
      .get(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        setUsers(response.data.transactions);

        const msg = response.data.message;
        var winamount = response.data.winAmount;
        setwinamount(winamount);
        if (res != undefined) {
          const objectRes = JSON.parse(res);

        }
        const withdrawTransactions = response.data.transactions.filter(
          (transaction) => transaction.type === "Withdraw"
        );
        console.log(withdrawTransactions)
        const totalSuccessAmount = withdrawTransactions
          .filter((transaction) => transaction.status === "Success" || transaction.status === "Pending")
          .reduce((acc, transaction) => acc + transaction.amount, 0);
        console.log(totalSuccessAmount)

        settotalSuccessAmount(totalSuccessAmount)
      })
      .finally(() => {
        setLoadingwithdraw(false);
      });
  };

  const user_id = localStorage.getItem("userid");
  const dev_id = localStorage.getItem("dev_id");
  const [inputValuedeposit, setInputValuedeposit] = useState("");

  const handleAdd = () => {
    if (!inputValuedeposit || inputValuedeposit < 100) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: "Amount must be minimum 100!",
      });
      return;
    }

    navigate("/PaymentType", { state: { amount: inputValuedeposit } });
  };

  const handleDeposit = async () => {
    if (!inputValuedeposit || isNaN(inputValuedeposit) || inputValuedeposit <= 0) {
      toast.error("Please enter a valid deposit amount!");
      return;
    }

    const requestData = {
      userId: user_id, // Replace with dynamic user ID if available
      amount: parseFloat(inputValuedeposit),
      bankId: selectedBanks.bankId,
      bankName: selectedBanks.bankName,
      ifscCode: selectedBanks.ifscCode,
      accountNumber: selectedBanks.accountNumber,
      accountHolderName: selectedBanks.accountHolderName,
    };

    try {
      setLoading(true);

      if (requestData.bankId == '' || requestData.bankName == '' || requestData.ifscCode == '' || requestData.accountNumber == '' || requestData.accountHolderName == '') {
        setLoading(false);
        toast.error("Please select a bank!");
        return;
      }

      const response = await fetch(`https://api.Cash365days.in/user/deposit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (data.success == 1) {
        setLoading3(false);
        setIsButtonDisabled(true);
        Swal.fire({
          title: data.message,
          icon: 'success',
          timer: 2000
        }).then((result) => {
          // navigate(0);
          loaduser1();
        });
      } else {
        Swal.fire({
          title: data.message,
          timer: 3000,
          icon: 'error'
        });
      }

    } catch (error) {
      console.error("Error during deposit:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };




  // Withdrawal Api
  const [bankName, setBankName] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [otp, setotp] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [inputError, setInputError] = useState(false);
  const [bankNameError, setBankNameError] = useState(false);
  const [accountHolderNameError, setAccountHolderNameError] = useState(false);
  const [accountNumberError, setAccountNumberError] = useState(false);
  const [ifscCodeError, setIfscCodeError] = useState(false);
  const [otpError, setotpError] = useState(false);
  const [mobilnumbererror, setMobileNumberError] = useState(false);
  const [amounttrerror, setAmountError] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [accountHolderNameBank, setAccountHolderNameBank] = useState("");
  const [accountNumberBank, setAccountNumberBank] = useState("");
  const [accountNumberBank1, setAccountNumberBank1] = useState("");
  const [ifscCodeBank, setIfscCodeBank] = useState("");
  const [filteredValues, setFilteredValues] = useState([]);
  const [showList, setShowList] = useState(true);
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [timer, setTimer] = useState(60);
  const [confirmAccountNumberError, setConfirmAccountNumberError] = useState(false);

  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const intervalRef = useRef(null);

  const [bankList, setBankList] = useState([]);

  const [selectedBank, setSelectedBank] = useState(null);

  const inputRef = useRef(null);



  const fetchBankData = async () => {
    try {
      const user_id = localStorage.getItem("userid");

      if (!user_id) {
        throw new Error("User ID not found in local storage.");
      }

      setLoadingwithdraw(true);

      const url = `https://api.Cash365days.in/user/get-bank-details/${user_id}`;
      const response = await axios.get(url); // Using async/await

      if (response.status !== 200) {
        throw new Error(`Unexpected response status: ${response.status}`);
      }

      const bankDetails = response.data.normalbankDetails;

      if (!bankDetails) {
        throw new Error("Bank details not found in the response.");
      }

      console.warn("Fetched Bank Details:", bankDetails);

      // Update state
      setBankName(bankDetails.bankName || "N/A");
      setAccountHolderName(bankDetails.accountHolderName || "N/A");
      setAccountNumber(bankDetails.accountNumber || "N/A");
      setIfscCode(bankDetails.ifscCode || "N/A");

    } catch (error) {
      console.error("Error fetching bank details:", error.message);
    } finally {
      setLoadingwithdraw(false);
    }
  };

  // const handleBankSelection = (bank) => {
  //   setSelectedBank(bank);
  //   setBankName(bank.bankName);
  //   setAccountHolderName(bank.accountHolderName);
  //   setAccountNumber(bank.accountNumber);
  //   setIfscCode(bank.ifscCode);
  //   setShowList(false);
  // };


  useEffect(() => {
    fetchBankData();
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleClicksend = () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true);
      handleWithdrawal();
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        clearInterval(intervalRef.current);
        setIsButtonClicked(false);
      }, 3000);
    }
  };


  const handleWithdrawal = async () => {
    // if (totalSuccessAmount > balance) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Insufficient Balance",
    //     text: "The withdrawal amount cannot exceed the available wallet balance.",
    //   });
    //   return;
    // }

    // if (!inputValue || inputValue < 100) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Invalid Amount",
    //     text: "The minimum withdrawal amount is 100!",
    //   });
    //   return;
    // }
    try {
      setLoadingbutton(true);
      const errors = [];
      setInputError(false);
      setBankNameError(false);
      setAccountHolderNameError(false);
      setAccountNumberError(false);
      setIfscCodeError(false);

      const amountPattern = /^\d+(\.\d{1,2})?$/;
      const bankNamePattern = /^[A-Za-z\s]+$/;
      const accountHolderNamePattern = /^[A-Za-z\s]+$/;
      const accountNumberPattern = /^\d+$/;
      const ifscCodePattern = /^[A-Za-z\s\d]+$/;

      if (!selectedBanks.bankName.match(bankNamePattern)) {
        setBankNameError(true);
        errors.push('Please enter a valid bank name (letters and spaces only)');
      }


      if (!selectedBanks.accountNumber.match(accountNumberPattern)) {
        setAccountNumberError(true);
        errors.push('Please enter a valid account number (8-18 digits)');
      }

      if (!selectedBanks.accountHolderName.match(accountHolderNamePattern)) {
        setAccountHolderNameError(true);
        errors.push('Please enter a valid account holder name (letters and spaces only)');
      }

      if (!selectedBanks.ifscCode.match(ifscCodePattern)) {
        setIfscCodeError(true);
        errors.push('Please enter a valid IFSC code (e.g., ABCD1234567)');
      }
      if (!inputValue.match(amountPattern)) {
        setInputError(true);
        errors.push('Please enter a valid amount (e.g., 500 or 500.00)');
      }
      if (errors.length > 0) {

        const errorMessage = errors.join('\n');
        console.error(errorMessage);
        return;
      }
      if (!username) { // Allowing 4-20 alphanumeric characters & underscores
        setUsernameError(true);
        Swal.fire({
          icon: "error",
          title: "Username",
          text: "Please enter a valid username !",
        });
        return;
      } else {
        setUsernameError(false);
      }
      const user_id = localStorage.getItem("userid");
      const requestData = {
        userId: user_id,
        amount: parseInt(inputValue),
        accountHolderName: selectedBanks.accountHolderName,
        bankName: selectedBanks.bankName,
        accountNumber: selectedBanks.accountNumber,
        ifscCode: selectedBanks.ifscCode,
        userName: username
      };

      const url = `https://api.Cash365days.in/user/withdraw`;
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      };

      const response = await fetch(url, config);
      const data = await response.json();
      if (data.success == 1) {
        setLoading3(false);
        setIsButtonDisabled(true);
        Swal.fire({
          title: data.message,
          icon: 'success',
          timer: 2000
        }).then((result) => {
          // navigate(0);
          loaduser1();
          setBankName('');
          setAccountHolderName('');
          setAccountNumber('');
          setIfscCode('');
          setInputValuedeposit('');
          setSelectedBanks('')
          setUsername('')

        });
      } else {
        Swal.fire({
          title: data.message,
          timer: 3000,
          icon: 'error'
        });
      }
    } catch (error) {
      console.error('Error handling withdrawal:', error);
    } finally {
      setLoadingbutton(false);
    }
  };


  const handleButtonClick = (amount) => {
    setInputValue((prevValue) => {
      const newValue = prevValue ? parseInt(prevValue) + parseInt(amount) : parseInt(amount);
      return newValue.toString();
    });
  };

  const [mobilnumber, setmobilNumber] = useState("");
  const [amounttr, setAmounttr] = useState("");

  useEffect(() => {
    if (valueswithdraw) {
      setFilteredValues(
        valueswithdraw.filter(
          (item) =>
            item.bank_name &&
            bankName &&
            item.bank_name.toLowerCase().includes(bankName.toLowerCase())
        )
      );
    }
  }, [bankName, valueswithdraw]);

  // bankName list api

  useEffect(() => {
    const getBankList = async () => {
      try {
        const url = `https://api.Cash365days.in/user/get-bank-details/${user_id}`;

        const response = await fetch(url);
        const data = await response.json();

        const adminBanks = data.bankDetails?.filter(bank => bank.type === "user" && bank.status === "1") || [];

        setFilteredValues1(adminBanks);
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
    };

    getBankList();
  }, []);

  // Handle bank selection
  const handleBankSelect = (e) => {
    const selectedBankName = e.target.value;
    const selectedBankData = filteredValues1.find(bank => bank._id === selectedBankName);

    if (selectedBankData) {
      setSelectedBanks({
        bankId: selectedBankData._id,
        bankName: selectedBankData.bankName,
        ifscCode: selectedBankData.ifscCode,
        accountNumber: selectedBankData.accountNumber,
        accountHolderName: selectedBankData.accountHolderName,
      });
    } else {
      setSelectedBanks({
        bankId: "",
        bankName: "",
        ifscCode: "",
        accountNumber: "",
        accountHolderName: "",
      });
    }
  };


  // const handleDepositClick = () => {
  //   if (eposit_enabled == "on") {


  //     window.location.href = "/https://www.google.com/"; // apna link daal yaha
  //     return;
  //   }

  //   // 👉 normal flow
  //   handleAdd();
  // };


  const handleDepositClick = async () => {
    if (eposit_enabled === "on") {
      try {
        setLoading(true);

        // 👉 API call
        const response = await fetch("https://api.cash365days.in/user/online-deposit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // userId: userId,   
            // amount: amount,   
            userId: user_id,
            // amount: parseInt(inputValue),
            amount: parseFloat(inputValuedeposit),
          }),
        });

        const data = await response.json();

        console.log("Deposit API Response 👉", data);
        if (data?.success === 1 && data?.intent) {
          window.location.href = data.intent;
        } else {
          alert(data?.message);
          if (data?.message == "User not found") {
            // alert(data?.message);

            // 🧹 localStorage clear
            localStorage.clear();

            // 🔁 login page पर भेजो
            window.location.href = "/";
          }
        }

      } catch (err) {
        console.error("Deposit error", err);
      } finally {
        setLoading(false);
      }

      return;
    }

    // 👉 normal flow
    handleAdd();
  };



  const handleCheckStatus = async (orderid) => {
    try {
      const res = await axios.post(
        "https://api.cash365days.in/user/payment-check-status",
        {
          orderid: orderid,
        }
      );

      console.log(res.data);

      // ✅ Success check
      if (res.data.message === "Success") {
        Swal.fire({
          title: "Success",
          text: "Status updated will be soon",
          icon: "success",
          timer: "3000",
          confirmButtonText: "OK",
        }).then(() => {
          // window.location.reload(); // 👈 reload
        });
      }

    } catch (error) {
      console.error(error);

      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  return (
    <>
      <section id="wallet" className="margin-bottom-88 mt-0 walletdesign_all">
        <div className="backbuttonall d-flex justify-content-between align-items-center">
          <div className="backbutton" onClick={() => Navigatehome()}>
            <IoArrowBackSharp />
          </div>
          <div className="pagetitle">
            <span>Deposit</span>
          </div>
          <div className="walletamt d-flex align-items-center">
            <div className="iconwallwt">
              <PiHandDepositFill />

            </div>
            <p>Deposit <span></span> </p>
          </div>
        </div>
        <Container fluid className="p-0 margin-bottom-70">
          <div className="homecontainer">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="first"
              className="w-100"
            >
              {/* <div className="">
                <div className="tabs_wallet">
                  <Nav variant="pills" className="tabslinks">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="first"
                        className="text-center AddPoint"
                      >
                        Deposit
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div> */}
              <div>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className="tab_content_one position-relative">
                      <div className="addfundwallet">
                        <div className="bankicon">
                          <Icon.Bank />
                        </div>
                        <input
                          type="number"
                          value={inputValuedeposit}
                          onChange={(e) => setInputValuedeposit(e.target.value)}
                          required
                          className="form-control addamountinput"
                          placeholder="Enter deposit amount (Min: 100)"
                        />


                      </div>
                      <div className="button-amount d-flex flex-wrap">
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("500")}
                        >
                          ₹ 500
                        </button>
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("1000")}
                        >
                          ₹ 1000
                        </button>
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("2500")}
                        >
                          ₹ 2500
                        </button>
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("5000")}
                        >
                          ₹ 5000
                        </button>
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("7500")}
                        >
                          ₹ 7500
                        </button>
                        <button
                          className="btn-amount"
                          onClick={() => handleButtonClickdeposit("10000")}
                        >
                          ₹ 10000
                        </button>

                      </div>
                      <p className="description mt-2 text-danger">
                        {appmanager && appmanager.dep_message}
                      </p>
                      <center>
                        <div className="d-flex justify-content-between mt-2">
                          {/* <button
                            className=" btnaddpoints"
                            disabled={loading}
                            onClick={handleAdd}
                          >
                            Deposit
                            {loading && <Spinner animation="border" />}
                          </button> */}
                          <button
                            className="btnaddpoints"
                            disabled={loading}
                            onClick={handleDepositClick}
                          >
                            Deposit
                            {loading && <Spinner animation="border" />}
                          </button>

                        </div>
                      </center>
                    </div>
                    <div className="deposittitle">
                      <p className="mb-0">
                        Deposit History
                      </p>
                    </div>
                    <div className="table-responsive">


                      <Table striped bordered hover className="table_deposit">
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Pay Mode</th>
                            <th>Date</th>
                            <th>Points </th>
                            {/* <th>Closing Balance </th> */}
                            <th>Status </th>
                            <th>Reason</th>
                          </tr>
                        </thead>
                        <tbody className="position-relative">
                          {loadingwallet ? (
                            <>
                              <div className="loadernew">
                                <img
                                  src={loading1}
                                  className="px-2 loaderfile"
                                  style={{ width: "50px" }}
                                  alt="Loading..."
                                />
                              </div>
                            </>
                          ) : users.length > 0 ? (
                            users &&
                            users?.filter((value) => value.type === "Deposit").map((values, index) => {
                              const dateTime = new Date(values.datetime);
                              const formattedDate = `${dateTime.getDate()}-${dateTime.getMonth() + 1
                                }-${dateTime.getFullYear()} ${dateTime.getHours()}:${dateTime.getMinutes()}`;
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {values.remark} {values.market}
                                  </td>
                                  {/* <td>{new Date(values.createdAt).toLocaleDateString()}</td> */}
                                  <td>
                                    {new Date(values.createdAt).toLocaleString("en-IN", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </td>                                  <td>{values.amount}</td>
                                  {/* <td>{values.balance}</td> */}
                                  <td className="text-success">
                                    {" "}
                                    <span
                                      style={{
                                        color:
                                          values.status === "Success"
                                            ? "green"
                                            : values.status === "Pending"
                                              ? "orange"
                                              : "red",
                                      }}
                                    >
                                      {values.status}
                                    </span>

                                  </td>
                                  <td style={{ maxWidth: '100px' }}>
                                    {values.status == "Pending" && (
                                      <button onClick={() => handleCheckStatus(values.orderid)}>
                                        Check Status
                                      </button>
                                    )}
                                  </td>

                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="10"
                                className="text-center nodataavl"
                              >
                                {" "}
                                No data available or something went wrong.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {users && users.length >= loadbuttonshow ? (
                        <div className="d-flex justify-content-center loadmore">
                          <button
                            className="btn btn-primary w-50  mx-auto text-center"
                          // onClick={shoot}
                          >
                            Load More
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </Container>
        <ToastContainer />
      </section>
      {loading2 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {loading3 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
    </>
  );
}
